import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Product, ProductPicture } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { WistaAMSTypes } from 'src/app/wista-ams-types';

@Component({
  selector: 'app-product-tile-preview',
  templateUrl: './product-tile-preview.component.html',
  styleUrls: ['./product-tile-preview.component.css']
})
export class ProductTilePreviewComponent implements OnInit {
  
  productName: string = "";
  productNumber: string = "";

  _product: Product;
  @Input() set product(product: Product){
    this._product = product;
    if(product){
      this.productName = product.productservice;
      this.productNumber = product.productnumber;
      this.productPictureLoading = true;
      this._dataService.resolve(WistaAMSTypes.ProductPicture, product.productid, (result: ProductPicture) => {
        this.productPictureData = this.getPictureData(result);
        this.productPictureLoading = false;
      });
    }
  }
  get product(): Product {
    return this._product;
  }

  @Output() onAdd: EventEmitter<any> = new EventEmitter();

  _count: number;
  @Input() set count(value: number){
    this._count = value;
  }
  get count(): number {
    return this._count;
  }

  productPictureLoading: boolean = false;
  productPictureData: string;

  constructor(
    private _dataService: DataService
  ) { }

  addProduct(){
    this.onAdd.emit();
  }

  /**
   * the method generates the img src data for an image
   */
  getPictureData(picture: ProductPicture) {
    return "data:" + picture.picturemediatype + ";base64," + picture.picturedata;
  }

  ngOnInit(): void {
  }

}
